import { useAppSelector } from "../../index";

export const useLoginForm = () => {
  return useAppSelector((state) => state.login.form);
};

export const useResetPasswordForm = () => {
  return useAppSelector((state) => state.login.resetPasswordForm);
};
